import { useQuery } from '@tanstack/react-query'
import epsClient from 'enrollment-platform/api/eps.client'
import { useEffect } from 'react'
import type { TemplateType } from '../../../models/templateType'
import type { MappingRule } from '../types'
import { importRulesJSON } from '../utils/transformer'

interface SourceTemplateEntry {
  id: string
  type?: TemplateType
  name?: string
  description?: string
  changeSummary?: string
  status?: string
  mappingRules: {
    schema_version: string
    computed_fields?: unknown[]
    mapping_rules: unknown[]
  }
}

export default function useSourceTemplate(
  clientId: string,
  sourceTemplateId: string | undefined,
  setMappingRules: (rules: MappingRule[]) => void,
  setComputedFields: (rules: MappingRule[]) => void
) {
  const { data: sourceTemplate, isPending } =
    useQuery<SourceTemplateEntry | null>({
      queryKey: ['hris-mapping-template-source', sourceTemplateId],
      queryFn: async () => {
        const result = await epsClient.get(
          `/api/v1/hris-mapping-templates/client/${clientId}`
        )
        const templates: SourceTemplateEntry[] = result.data
        return templates.find((t) => t.id === sourceTemplateId) ?? null
      },
      enabled: !!sourceTemplateId && !!clientId,
    })

  useEffect(() => {
    if (!sourceTemplate?.mappingRules?.mapping_rules) return
    const imported = importRulesJSON(
      JSON.stringify(sourceTemplate.mappingRules)
    )
    setMappingRules(imported.mappingRules)
    setComputedFields(imported.computedFields)
  }, [sourceTemplate, setMappingRules, setComputedFields])

  return { sourceTemplate, isLoading: isPending && !!sourceTemplateId }
}
